export const FINANCIAL_PATHS = ["/user/financials", "/user/depositsummary"];

export const CLIENTS_PATH = "/user/clients?type=policy";

export const CLIENT_ONLY_HIDDEN_PATHS = [...FINANCIAL_PATHS, "/user/dashboard", "/user/security"];

export const isClientOnlyForAllDistros = (user) => {
    const distros = user?.distros || [];
    return distros.length > 0 && distros.every((d) => d.isClientOnly);
};

export const isClientOnlyForDistro = (currentUser, currentDistro) => {
    if (!currentUser || currentUser.role === "advisor") return false;
    const distro = (currentUser.distros || []).find((d) => d.id === currentDistro);
    return !!distro?.isClientOnly;
};

export const withoutFinancialLinks = (links) =>
    links.filter((link) => !FINANCIAL_PATHS.includes(link.path ?? link.to));

export const withoutRestrictedLinks = (links) =>
    links.filter((link) => !CLIENT_ONLY_HIDDEN_PATHS.includes(link.path ?? link.to));

const sameDistros = (a, b) =>
    a.length === b.length &&
    a.every((d, i) => d.id === b[i].id && d.name === b[i].name && !!d.isClientOnly === !!b[i].isClientOnly);

export const reconcileFirmAccess = (currentUser, currentDistro, distros) => {
    if (distros.length === 0) return { signOut: true };

    const previous = currentUser?.distros || [];
    const before = previous.find((d) => d.id === currentDistro);
    const after = distros.find((d) => d.id === currentDistro);

    let nextDistro = currentDistro;
    let notice = null;
    if (currentDistro && !after) {
        nextDistro = distros.length === 1 ? distros[0].id : null;
        if (before) notice = `Your access to ${before.name} has been removed.`;
    } else if (before && after && !!before.isClientOnly !== !!after.isClientOnly) {
        notice = `Your access to ${after.name} has changed.`;
    }

    return { signOut: false, changed: !sameDistros(previous, distros), nextDistro, notice };
};
